import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Check, XCircle, Loader2 } from 'lucide-react';

const API_BASE = `${(process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '')}/api/v1`;

export default function PublicRegistrationConfirm() {
  const { tenantSlug, token } = useParams();
  const [state, setState] = useState({ status: 'loading', error: null, data: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(
          `${API_BASE}/public/registrations/${encodeURIComponent(tenantSlug)}/confirm/${encodeURIComponent(token)}`,
        );
        if (!cancelled) setState({ status: 'ok', error: null, data: r.data });
      } catch (e) {
        if (!cancelled) {
          setState({
            status: 'error',
            error: e?.response?.data?.detail || 'Link ungültig oder abgelaufen.',
            data: null,
          });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [tenantSlug, token]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div
        className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center"
        data-testid="public-registration-confirm-card"
      >
        {state.status === 'loading' && (
          <div className="flex items-center justify-center gap-2 text-slate-600" data-testid="public-registration-confirm-loading">
            <Loader2 className="h-5 w-5 animate-spin" /> Bestätigung wird geprüft …
          </div>
        )}

        {state.status === 'ok' && (
          <div data-testid="public-registration-confirm-ok">
            <div className="w-12 h-12 rounded-full mx-auto flex items-center justify-center mb-3 bg-emerald-50 text-emerald-600">
              <Check className="h-6 w-6" />
            </div>
            <h1 className="text-2xl font-semibold text-slate-900 mb-2">
              {state.data?.already_confirmed ? 'Bereits bestätigt' : 'Vielen Dank!'}
            </h1>
            <p className="text-slate-600">
              {state.data?.already_confirmed
                ? 'Deine Anmeldung wurde bereits bestätigt. Die Verwaltung meldet sich bei dir.'
                : 'Deine Anmeldung wurde bestätigt. Die Verwaltung der Musikschule prüft jetzt deine Angaben und meldet sich in den nächsten Werktagen bei dir.'}
            </p>
            <p className="text-sm text-slate-500 mt-4">
              {state.data?.tenant_name}
            </p>
          </div>
        )}

        {state.status === 'error' && (
          <div data-testid="public-registration-confirm-error">
            <div className="w-12 h-12 rounded-full mx-auto flex items-center justify-center mb-3 bg-red-50 text-red-600">
              <XCircle className="h-6 w-6" />
            </div>
            <h1 className="text-2xl font-semibold text-slate-900 mb-2">Bestätigung fehlgeschlagen</h1>
            <p className="text-slate-600">{state.error}</p>
            <p className="text-sm text-slate-500 mt-4">
              Bitte starte die Anmeldung erneut oder wende dich an die Musikschule.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
